import { AbstractControl } from '@angular/forms';

export const ALIAS_VALIDATOR_MESSAGE = 'Invalid format supplied';

export function aliasValidator(
    control: AbstractControl
): { [key: string]: any } | null {
    if (control.value === '') {
        return null;
    }
    const valid = /^[A-Za-z0-9_]+$/.test(control.value);
    return valid
        ? null
        : { invalidAlias: { valid: false, value: control.value } }
}